import script from "./BackArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./BackArrow.vue?vue&type=script&setup=true&lang=js"

import "./BackArrow.vue?vue&type=style&index=0&id=0087a0c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0087a0c0"]])

export default __exports__